export enum MessageType
{
    Info = '',
    Error = 'error',
    Success = 'success'
}